'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Glyphicon = require('react-bootstrap/lib/Glyphicon');

var _Glyphicon2 = _interopRequireDefault(_Glyphicon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Glyphicon2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Glyphicon.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Glyphicon.js
 ** module chunks = 0
 **/